<template>
  <div>
    <b-form
      class="position-relative"
    >
      <b-row>
        <b-col md="12">
          <b-card
            border-variant="success"
            bg-variant="transparent"
            class="shadow-none module-card"
          >
            <b-overlay
              :show="busy"
              rounded="lg"
              opacity="0.6"
            >
              <template #overlay>
                <div class="d-flex align-items-center">
                  <b-spinner
                    small
                    type="grow"
                    variant="secondary"
                  />
                  <b-spinner
                    type="grow"
                    variant="dark"
                  />
                  <b-spinner
                    small
                    type="grow"
                    variant="secondary"
                  />

                  <!-- We add an SR only text for screen readers -->
                  <span class="sr-only">{{ $t('DEBTIA_PLEASE_WAIT_MSG') }}</span>
                </div>
              </template>
              <b-form-group
                :label="$t('DEBTIA_RECEIPIENT')"
                label-for="receipient"
              >
                <v-select
                  v-model="receipient"
                  :disabled="busy"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="ReceipientOptions"
                  :reduce="val => val.value"
                  :clearable="false"
                  input-id="receipient"
                />
              </b-form-group>
              <b-form-group
                v-if="receipient === 'debtia.receipientsContact'"
                :label="$t('DEBTIA_CONTACT')"
                label-for="receipient"
              >
                <v-select
                  v-model="contact"
                  :disabled="busy"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="contactOptions"
                  :reduce="val => val.value"
                  :clearable="false"
                  input-id="contact"
                />
              </b-form-group>
              <b-form-group
                :label="$t('DEBTIA_LETTER_TEMPLATE_TEXT')"
                label-for="letter_template"
                :aria-hidden="busy ? 'true' : null"
              >
                <v-select
                  v-model="letterTemplate"
                  :disabled="busy"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="letterTemplateOptions"
                  :reduce="val => val.value"
                  :clearable="false"
                  :input-id="'letter-template'"
                  @input="changeTemplate()"
                />
              </b-form-group>
              <b-form-group
                :label="$t('DEBTIA_FILE_CATEGORIES')"
                label-for="file-category"
              >
                <v-select
                  v-model="fileCategory"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="fileCategories"
                  :reduce="val => val.value"
                  :clearable="false"
                  multiple
                  input-id="file-category"
                />
              </b-form-group>
            </b-overlay>
            <b-form-group
              v-for="(data,index) in templateVariables"
              :key="index"
              :label="data.id"
              label-for="email_template"
              :aria-hidden="busy ? 'true' : null"
            >
              <div :id="'div-wrapper-'+data.id">
                <v-select
                  :disabled="busy"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="templateVariableOptions"
                  :reduce="val => val.value"
                  :clearable="false"
                  :input-id="'letter-template-'+data.id"
                  :class="'letter-template-'+data.id"
                  @input="changeVariable($event, data, index)"
                >
                  <template
                    slot="option"
                    slot-scope="option"
                  >
                    <div :class="assignClass(option.value) ? 'autofik' : ''">
                      {{ option.label }}
                    </div>
                  </template>
                </v-select>
                <b-row
                  :id="'date-'+data.id"
                  class="showdates"
                >
                  <b-col md="12">
                    <b-form-group
                      label="Select number of days after letter generation"
                      label-for="letter_template"
                    >
                      <b-form-input
                        :id="'noOfDays-'+data.id"
                        type="number"
                        @change="noOfDaysChange($event, data.id)"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row
                  :id="'currency-conversion-'+data.id"
                  class="showdates"
                >
                  <b-col md="12">
                    <b-form-group
                      label="Select The Statement"
                      :label-for="'currency-statement-'+data.id"
                    >
                      <v-select
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="statementsOptions"
                        :reduce="val => val.value"
                        :clearable="false"
                        :input-id="'currency-statement-'+data.id"
                        @input="currencyStatementChange($event, data.id)"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group
                      label="Convert to Currency"
                      :label-for="'convert-currency-'+data.id"
                    >
                      <v-select
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="convertCurrenciesOptions"
                        :reduce="val => val.value"
                        :clearable="false"
                        :input-id="'convert-currency-'+data.id"
                        @input="currencyConversionChange($event, data.id)"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row
                  :id="'interestrate-percentage-'+data.id"
                  class="showdates"
                >
                  <b-col md="12">
                    <b-form-group
                      label="Select Base Document Type"
                      :label-for="'base-document-types-'+data.id"
                    >
                      <v-select
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="baseDocumentTypes"
                        :reduce="val => val.value"
                        :clearable="false"
                        multiple
                        :input-id="'base-document-types-'+data.id"
                        @input="documentTypeChange($event, data.id)"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group
                      label="To Fetch"
                      :label-for="'fetching-document-'+data.id"
                    >
                      <v-select
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="fetchingDocumentsOptions"
                        :reduce="val => val.value"
                        :clearable="false"
                        :input-id="'fetching-document-'+data.id"
                        @input="fetchingDocumentChange($event, data.id)"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row
                  :id="'run-date-'+data.id"
                  class="showdates"
                >
                  <b-col md="12">
                    <b-form-group
                      label="Select Module"
                      :label-for="'prev-module-dropdown-'+data.id"
                    >
                      <v-select
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="prevModuleOptions"
                        :reduce="val => val.value"
                        :clearable="false"
                        :input-id="'prev-module-dropdown-'+data.id"
                        @input="moduleChange($event, data.id)"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row
                  v-if="data.mappable"
                  :id="'conditional-mappable-'+data.id"
                  class="showdates"
                >
                  <conditional-mappable
                    v-if="data.mappable"
                    :ref="`conditionalChild-${data.id}`"
                    :conditions="conditions"
                    :data="data.id"
                    :busy="busy"
                    :statement-condition-i-d="statementConditionID"
                    :client-type-condition-i-d="clientTypeConditionID"
                    :interest-type-condition-i-d="interestTypeConditionID"
                    :airports-data="AirportsData"
                    :email-var="conditionalLetterVar"
                    :convert-currencies-options="convertCurrenciesOptions"
                    :assign-class="assignClass"
                    :prev-module-options="prevModuleOptions"
                    :statements-options="statementsOptions"
                    :mappable-id="data.id"
                    :template-variable-options="templateVariableOptions.filter(item => item.value !== 'conditional_mappable')"
                    :component-object="lettervariables[data.id]"
                    :remove-error-msg="removeErrorMsg"
                    :letter-templates="letterTemplateOptions"
                    :statements="statements"
                    :email-template-id="email_template_id"
                    module-type="letter"
                    :client-collection-type-i-d="clientCollectionTypeID"
                    @childData="getConditions"
                  />
                </b-row>
                <b-row
                  :id="'letter-sent-date-'+data.id"
                  class="showdates"
                >
                  <b-col
                    :id="'case-presentation-statements-'+data.id"
                    md="12"
                  >
                    <b-form-group
                      label="Collection Fee Statement"
                      :label-for="'case-presentation-'+data.id"
                    >
                      <v-select
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="statements"
                        :reduce="val => val.value"
                        :clearable="false"
                        :input-id="'case-presentation-'+data.id"
                        @input="collectionStatement($event, data.id)"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group
                      label="Select Letter Template"
                      :label-for="'select-letter-template-'+data.id"
                    >
                      <v-select
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="letterTemplateOptions"
                        :reduce="val => val.value"
                        :clearable="false"
                        multiple
                        :input-id="'select-letter-template-'+data.id"
                        @input="sentLetterChange($event, data.id)"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col
                    :id="'letter-sent-date-order-'+data.id"
                    md="12"
                  >
                    <b-form-group
                      label="To Fetch"
                      :label-for="'fetching-letters-'+data.id"
                    >
                      <v-select
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="fetchingLettersOptions"
                        :reduce="val => val.value"
                        :clearable="false"
                        :input-id="'fetching-letters-'+data.id"
                        @input="fetchingLetterChange($event, data.id)"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row
                  :id="'free-text-'+data.id"
                  class="showdates"
                >
                  <b-col md="12">
                    <b-form-group
                      label="Free Text Note"
                      :label-for="'freeTextField-'+data.id"
                    >
                      <b-form-input
                        :id="'freeTextField-'+data.id"
                        @change="assignFreeTextNote($event, data.id)"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row
                  :id="'payment-link-'+data.id"
                  class="showdates"
                >
                  <div
                    class="amount-period-base-divs"
                  >
                    <b-col
                      class="optionsClass"
                      md="12"
                    >
                      <b-form-checkbox
                        :id="'amount_based_plan-'+data.id"
                        class="custom-control-primary"
                        @change="updateInstallmentPlanFields($event, data.id, 'amount_based_plan')"
                      >
                        {{ $t('DEBTIA_AMOUNT_BASE_PLAN') }}
                      </b-form-checkbox>
                    </b-col>
                    <b-col
                      :id="'col-min_amount-'+data.id"
                      style="display: none"
                      md="12"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_MIN_AMOUNT')"
                        :label-for="'min_amount-'+data.id"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="Min. Amount"
                          rules="required"
                        >
                          <b-form-input
                            :id="'min_amount-'+data.id"
                            type="number"
                            placeholder="Min. Amount"
                            :state="errors.length > 0 ? false:null"
                            :input-id="'min_amount-'+data.id"
                            @input="updateInstallmentPlanFields($event, data.id, 'min_amount'), removeErrorBorder('min_amount-'+data.id, 0)"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                          <small
                            v-if="minAmountError"
                            class="text-danger dd"
                          >The min amount must be at least 100</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                  </div>
                  <div
                    class="amount-period-base-divs"
                  >
                    <b-col
                      class="optionsClass"
                      md="12"
                    >
                      <b-form-checkbox
                        :id="'period_based_plan-'+data.id"
                        class="custom-control-primary"
                        @change="updateInstallmentPlanFields($event, data.id, 'period_based_plan')"
                      >
                        {{ $t('DEBTIA_PERIOD_BASE_PLAN') }}
                      </b-form-checkbox>
                    </b-col>
                    <b-col
                      :id="'col-max_months-'+data.id"
                      style="display: none"
                      md="12"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_MAX_MONTH')"
                        :label-for="'max_months-'+data.id"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="Max. Months"
                          rules="required"
                        >
                          <b-form-input
                            :id="'max_months-'+data.id"
                            type="number"
                            placeholder="Max. Month"
                            :state="errors.length > 0 ? false:null"
                            :input-id="'max_months-'+data.id"
                            @input="updateInstallmentPlanFields($event, data.id, 'max_months'), removeErrorBorder('max_months-'+data.id, 0)"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                          <small
                            v-if="maxMonthsError"
                            class="text-danger dd"
                          >The max months must be at least 1.</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                  </div>
                  <b-col
                    :id="'col-interest_free_months-'+data.id"
                    style="display: none"
                    md="12"
                  >
                    <b-form-group
                      :label="$t('DEBTIA_INTEREST_FREE_MONTHS')"
                      :label-for="'interest_free_months-'+data.id"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Interest Free Months"
                        rules="required"
                      >
                        <b-form-input
                          :id="'interest_free_months-'+data.id"
                          type="number"
                          :state="errors.length > 0 ? false:null"
                          placeholder="Interest Free Months"
                          :input-id="'interest_free_months-'+data.id"
                          @change="updateInstallmentPlanFields($event, data.id, 'interest_free_months'), removeErrorBorder('interest_free_months-'+data.id, 0)"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                        <small
                          v-if="interestFreeMonthsError"
                          class="text-danger"
                        >{{ $t('DEBTIA_INTEREST_FREE_POSITIVE') }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col
                    :id="'col-payment_date-'+data.id"
                    style="display: none"
                    md="12"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Installment Start Date"
                      rules="required"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_INSTALLMENT_START_DATE')"
                        :label-for="'payment_date-'+data.id"
                        :state="errors.length > 0 ? false:null"
                      >
                        <v-select
                          :id="'payment_date-'+data.id"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :options="paymentDateOptions"
                          :reduce="val => val.value"
                          :clearable="false"
                          :input-id="'payment_date-'+data.id"
                          @input="updateInstallmentPlanFields($event, data.id, 'payment_date'), removeErrorBorder('payment_date-'+data.id, 1)"
                        />
                        <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                          {{ errors[0] }}
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>
              </div>
            </b-form-group>
            <b-form-group
              class="optionsClass"
              md="12"
            >
              <b-form-checkbox
                id="allow-skip-email"
                v-model="skipEmail"
                class="custom-control-primary"
              >
                {{ $t('DEBTIA_SKIP_SENDING_EMAIL') }}
              </b-form-checkbox>
            </b-form-group>
            <b-form-group
              :label="$t('DEBTIA_WHICH_DAYS_CAN_IT_SEND')"
              label-for="send-days"
            >
              <b-row>
                <b-col
                  v-for="day in daysOptions"
                  :key="day.value"
                  cols="8"
                  md="4"
                  class="mb-2"
                >
                  <b-form-checkbox
                    v-model="selectedDays"
                    :value="day.value"
                  >
                    {{ day.label }}
                  </b-form-checkbox>
                </b-col>
              </b-row>
            </b-form-group>
            <b-button
              v-if="templateVariables.length > 0"
              class="emailSubmitBtn"
              variant="primary"
              type="submit"
              @click.prevent="submitSendLetterForm"
            >
              <b-spinner
                v-if="spinnerOn"
                small
                class="mr-1"
                label="Small Spinner"
              />
              <span v-else>{{ $t('DEBTIA_SUBMIT') }}</span>
            </b-button>
            <span
              v-if="errorMsg"
              id="fieldserror"
            >{{ $t('DEBTIA_HIGHLIGHT_FIELD_MSG') }}</span>
            <span
              v-if="daysError"
              id="fieldserror"
            >{{ $t('DEBTIA_DAYS_ERROR') }}</span>
          </b-card>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>

import vSelect from 'vue-select'
import {
  BFormGroup,
  BForm,
  BRow,
  BCol,
  BButton,
  BOverlay,
  BCard,
  BSpinner,
  BFormInput, BFormCheckbox, BFormInvalidFeedback,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import axios from '@axios'
import constants from '@/app-configs/constants'
import { ValidationProvider } from 'vee-validate'
import axiosletter from '../../../libs/axiosletter'
import ConditionalMappable from './ConditionalMappable.vue'

export default {
  components: {
    BForm,
    BRow,
    BCol,
    BFormGroup,
    vSelect,
    BOverlay,
    BSpinner,
    BCard,
    BButton,
    BFormInput,
    ConditionalMappable,
    ValidationProvider,
    BFormCheckbox,
    BFormInvalidFeedback,
  },
  directives: {
    Ripple,
  },
  props: {
    conditionObject: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      currentVariable: '',
      busy: false,
      letterTemplate: '',
      letterTemplateTitle: '',
      letterTemplateOptions: [],
      templateVariables: [],
      templateVariableOptions: [],
      lettervariables: {},
      errorMsg: false,
      spinnerOn: false,
      dateval: '',
      inputdays: 0,
      contact: 0,
      ReceipientOptions: [
        { label: 'Creditor', value: 'debtia.receipientsClient' },
        { label: 'Debtor(s)', value: 'debtia.receipientsDebtor' },
        { label: 'Partner (s)', value: 'debtia.receipientsPartner' },
        { label: 'Court', value: 'debtia.receipientsCourt' },
        { label: 'Contact', value: 'debtia.receipientsContact' },
      ],
      contactOptions: [],
      receipient: 'debtia.receipientsClient',
      receipientArgs: {},
      receipientVars: {
        'debtia.receipientsClient': 'debtiaReceipientsClient',
        'debtia.receipientsDebtor': 'debtiaReceipientsDebtors',
        'debtia.receipientsPartner': 'debtiaReceipientsPartners',
        'debtia.receipientsCourt': 'debtiaReceipientsCourt',
        'debtia.receipientsContact': 'debtiaReceipientsContact',
      },
      fetchingDocumentsOptions: [
        { label: 'First Base Document', value: 'first' },
        { label: 'Last Base Document', value: 'last' },
      ],
      baseDocumentTypes: [
        { label: 'Invoice (Faktura)', value: 1 },
        { label: 'Court Verdict (Dom) ', value: 2 },
        { label: 'Promissory note (Gældsbrev)', value: 3 },
        { label: 'Undefined/Other (Andet)', value: 4 },
      ],
      specialOptions: [
        { name: 'debtia.currencyConverter', label: 'DKK/EUR Converter' },
        { name: 'dato_felt', label: 'Select number of days after letter generation' },
        { name: 'auto_fik', label: '' },
        { name: 'debtia.recepient_name', label: 'Enter recepient name.' },
        { name: 'debtia.recepient_contact_person', label: 'Enter recepient contact person' },
        { name: 'debtia.recepient_road_name', label: 'Enter recepient address road name' },
        { name: 'debtia.recepient_house_number', label: 'Enter recepient house number' },
        { name: 'debtia.recepient_zipcode', label: 'Enter recepient zipcode' },
        { name: 'debtia.recepient_city', label: 'Enter recepient city' },
        { name: 'debtia.recepient_country', label: 'Enter recepient country' },
        { name: 'debtia.recepient_place', label: 'Enter recepient place' },
        { name: 'module_run_date', label: 'Module Run Date' },
        { name: 'interest_rate_percentage', label: 'Interest Rate Percentage' },
        { name: 'conditional_mappable', label: 'Conditional Mappable' },
        { name: 'letter_sent_date', label: 'Letter Sent Date' },
        { name: 'debtia.freeText', label: 'Free Text' },
        { name: 'debtia.paymentLink', label: 'Payment Link' },
      ],
      letter_client_id: '',
      letter_secret: '',
      fileCategories: [{
        label: 'Base Documents', value: 'baseDocuments',
      }],
      fileCategory: [],
      prevModuleOptions: [],
      convertCurrenciesOptions: [],
      statementsOptions: [],
      conditions: [],
      AirportsData: [],
      conditionalLetterVar: {},
      statementConditionID: 0,
      clientTypeConditionID: 0,
      componentObject: {
        condition_mappable: true,
        functional_value: null,
        condition_id: null, // req
        condition_value: 0, // req (when statements is selected then the value of the input field)
        subStatementValue: null,
        condition_operator_id: null, // req
        true_value: null,
        false_value: null,
        custom_variable_id: 0,
        custom_option_id: 0,
        custom_variable_value: 'debtor',
        file_category_id: 0,
        debt_case_group_id: 0,
        sub_statements: [],
        dateOption: 1,
        interest_type_condition: '',
        letterTemplates: this.letterTemplateOptions,
        statements: [],
        installmentPlanPayload: [],
        client_collection_type: '',
        client_type: '',
      },
      emptyMappableValues: false,
      emptyGeneralValues: false,
      emptyMappableTrueFalseValue: false,
      interestTypeConditionID: '',
      fetchingLettersOptions: [
        { label: 'First Letter', value: 'asc' },
        { label: 'Last Letter', value: 'desc' },
      ],
      baseDocumentAttachments: false,
      paymentDateOptions: [
        { label: 'Now', value: 'now' },
        { label: 'First day next month', value: 'first_day_next_month' },
      ],
      installmentStartDate: null,
      interestFreeMonths: '',
      minAmount: '',
      maxMonth: '',
      amountBasePlan: 0,
      periodBasePlan: 0,
      email_template_id: 0,
      minAmountError: false,
      maxMonthsError: false,
      interestFreeMonthsError: false,
      skipEmail: false,
      clientCollectionTypeID: 0,
      selectedDays: ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'],
      daysOptions: [
        { label: 'Monday', value: 'mon' },
        { label: 'Tuesday', value: 'tue' },
        { label: 'Wednesday', value: 'wed' },
        { label: 'Thursday', value: 'thu' },
        { label: 'Friday', value: 'fri' },
        { label: 'Saturday', value: 'sat' },
        { label: 'Sunday', value: 'sun' },
      ],
      daysError: false,
    }
  },
  async created() {
    await this.getApiSettings()
    await this.getFileCategories()
    await this.getCurrencyConversionParams()
    await this.getContacts()
    await this.getConditions()
    await this.getPreviousModules()
    await this.getStatements()
    await this.getTemplateId()
    this.busy = false
  },
  methods: {
    async getTemplateId() {
      await axios.get('/settings/get-default-action-template?action_id=9').then(settings => {
        if (settings.status) {
          this.email_template_id = settings.data.data.template_id
        }
      })
    },
    removeErrorMsg() {
      this.errorMsg = false
    },
    async getCurrencyConversionParams() {
      await axios.get('/settings/get-currency').then(response => {
        if (response.status) {
          this.convertCurrenciesOptions = response.data.data
        }
      })

      await axios.get('/get-all-statement-groups?dropdown=true').then(response => {
        if (response.status) {
          this.statementsOptions = response.data.data
        }
      })
    },
    async getContacts() {
      await axios.get('/contacts/get-all?dropdown=true').then(contacts => {
        if (contacts.status) {
          const options = contacts.data.data
          options.forEach(element => {
            const elementObj = { label: element.name, value: element.id }
            this.contactOptions.push(elementObj)
          })
        }
      })
    },
    async getApiSettings() {
      this.busy = true
      await axios.get('/api-token/default?module=physical-letters').then(settings => {
        if (settings.status) {
          this.letter_client_id = settings.data.data.client_id
          this.letter_secret = settings.data.data.secret
          this.getLetterTemplate()
        }
      })
    },
    turnFieldErrorOn(selector) {
      this.$el.querySelector(selector).classList.add('inputErrorClassField')
    },
    turnSelectErrorOn(selector) {
      const dropdown = document.querySelector(`${selector} .vs__dropdown-toggle`)
      dropdown.classList.add('inputErrorClassField')
    },
    mappableTrueFalse(values) {
      this.emptyMappableTrueFalseValue = false
      values.forEach(element => {
        if (this.lettervariables[element.id].true_value.variable === 'module_run_date' && !this.lettervariables[element.id].true_value.functional_value) {
          this.turnSelectErrorOn(`#${element.id}-true_value-module_run_date`)
          this.emptyMappableTrueFalseValue = true
        }
        if (this.lettervariables[element.id].true_value.variable === 'debtia.currencyConverter' && !this.lettervariables[element.id].true_value.statement_id) {
          this.turnSelectErrorOn(`#${element.id}-true_value-statement_id`)
          this.emptyMappableTrueFalseValue = true
        }
        if (this.lettervariables[element.id].true_value.variable === 'debtia.currencyConverter' && !this.lettervariables[element.id].true_value.currency_id) {
          this.turnSelectErrorOn(`#${element.id}-true_value-currency_id`)
          this.emptyMappableTrueFalseValue = true
        }
        if (this.lettervariables[element.id].true_value.variable === 'interest_rate_percentage' && this.lettervariables[element.id].true_value.base_types.length < 1) {
          this.turnSelectErrorOn(`#${element.id}-true_value-base_types`)
          this.emptyMappableTrueFalseValue = true
        }
        if (this.lettervariables[element.id].true_value.variable === 'interest_rate_percentage' && !this.lettervariables[element.id].true_value.document_order) {
          this.turnSelectErrorOn(`#${element.id}-true_value-document_order`)
          this.emptyMappableTrueFalseValue = true
        }
        if (this.lettervariables[element.id].false_value.variable === 'module_run_date' && !this.lettervariables[element.id].false_value.functional_value) {
          this.turnSelectErrorOn(`#${element.id}-false_value-module_run_date`)
          this.emptyMappableTrueFalseValue = true
        }
        if (this.lettervariables[element.id].false_value.variable === 'debtia.currencyConverter' && !this.lettervariables[element.id].false_value.statement_id) {
          this.turnSelectErrorOn(`#${element.id}-false_value-statement_id`)
          this.emptyMappableTrueFalseValue = true
        }
        if (this.lettervariables[element.id].false_value.variable === 'debtia.currencyConverter' && !this.lettervariables[element.id].false_value.currency_id) {
          this.turnSelectErrorOn(`#${element.id}-false_value-currency_id`)
          this.emptyMappableTrueFalseValue = true
        }
        if (this.lettervariables[element.id].false_value.variable === 'interest_rate_percentage' && this.lettervariables[element.id].false_value.base_types.length < 1) {
          this.turnSelectErrorOn(`#${element.id}-false_value-base_types`)
          this.emptyMappableTrueFalseValue = true
        }
        if (this.lettervariables[element.id].false_value.variable === 'interest_rate_percentage' && !this.lettervariables[element.id].false_value.document_order) {
          this.turnSelectErrorOn(`#${element.id}-false_value-document_order`)
          this.emptyMappableTrueFalseValue = true
        }
        if (this.lettervariables[element.id].true_value.variable === 'letter_sent_date' && this.lettervariables[element.id].true_value.letters.length < 1) {
          this.turnSelectErrorOn(`#${element.id}-true_value-send_letters`)
          this.emptyMappableTrueFalseValue = true
        }
        if (this.lettervariables[element.id].true_value.variable === 'letter_sent_date' && !this.lettervariables[element.id].true_value.order) {
          this.turnSelectErrorOn(`#${element.id}-true_value-order`)
          this.emptyMappableTrueFalseValue = true
        }
        if (this.lettervariables[element.id].false_value.variable === 'letter_sent_date' && this.lettervariables[element.id].false_value.letters.length < 1) {
          this.turnSelectErrorOn(`#${element.id}-false_value-send_letters`)
          this.emptyMappableTrueFalseValue = true
        }
        if (this.lettervariables[element.id].false_value.variable === 'letter_sent_date' && !this.lettervariables[element.id].false_value.order) {
          this.turnSelectErrorOn(`#${element.id}-false_value-order`)
          this.emptyMappableTrueFalseValue = true
        }
        if (this.lettervariables[element.id].true_value.variable === 'debtia.paymentLink'
          && (this.lettervariables[element.id].true_value.amount_based_plan
            && (!this.lettervariables[element.id].true_value.min_amount || (this.lettervariables[element.id].true_value.min_amount && !(this.lettervariables[element.id].true_value.min_amount >= 100))))) {
          this.turnFieldErrorOn(`#min_amount-${element.id}-true_value`)
          this.emptyMappableTrueFalseValue = true
        }
        if (this.lettervariables[element.id].false_value.variable === 'debtia.paymentLink'
          && (this.lettervariables[element.id].false_value.amount_based_plan
            && (!this.lettervariables[element.id].false_value.min_amount || (this.lettervariables[element.id].false_value.min_amount && !(this.lettervariables[element.id].false_value.min_amount >= 100))))) {
          this.turnFieldErrorOn(`#min_amount-${element.id}-false_value`)
          this.emptyMappableTrueFalseValue = true
        }
        if (this.lettervariables[element.id].true_value.variable === 'debtia.paymentLink'
            && (this.lettervariables[element.id].true_value.period_based_plan
              && (!this.lettervariables[element.id].true_value.max_months
                || (this.lettervariables[element.id].true_value.max_months && !(this.lettervariables[element.id].true_value.max_months > 0))))) {
          this.turnFieldErrorOn(`#max_months-${element.id}-true_value`)
          this.emptyMappableTrueFalseValue = true
        }
        if (this.lettervariables[element.id].false_value.variable === 'debtia.paymentLink'
            && (this.lettervariables[element.id].false_value.period_based_plan
              && (!this.lettervariables[element.id].false_value.max_months
                || (this.lettervariables[element.id].false_value.max_months && !(this.lettervariables[element.id].false_value.max_months > 0))))) {
          this.turnFieldErrorOn(`#max_months-${element.id}-false_value`)
          this.emptyMappableTrueFalseValue = true
        }
        if (this.lettervariables[element.id].true_value.variable === 'debtia.paymentLink'
            && ((this.lettervariables[element.id].true_value.amount_based_plan || this.lettervariables[element.id].true_value.period_based_plan)
              && (!this.lettervariables[element.id].true_value.interest_free_months
                || (this.lettervariables[element.id].true_value.interest_free_months
                  && !(this.lettervariables[element.id].true_value.interest_free_months >= 0))))) {
          this.turnFieldErrorOn(`#interest_free_months-${element.id}-true_value`)
          this.emptyMappableTrueFalseValue = true
        }
        if (this.lettervariables[element.id].false_value.variable === 'debtia.paymentLink'
            && ((this.lettervariables[element.id].false_value.amount_based_plan || this.lettervariables[element.id].false_value.period_based_plan)
              && (!this.lettervariables[element.id].false_value.interest_free_months
                || (this.lettervariables[element.id].false_value.interest_free_months
                  && !(this.lettervariables[element.id].false_value.interest_free_months >= 0))))) {
          this.turnFieldErrorOn(`#interest_free_months-${element.id}-false_value`)
          this.emptyMappableTrueFalseValue = true
        }
        if (this.lettervariables[element.id].true_value.variable === 'debtia.paymentLink' && ((this.lettervariables[element.id].true_value.amount_based_plan || this.lettervariables[element.id].true_value.period_based_plan) && !this.lettervariables[element.id].true_value.payment_date)) {
          this.turnSelectErrorOn(`#payment_date-${element.id}-true_value`)
          this.emptyMappableTrueFalseValue = true
        }
        if (this.lettervariables[element.id].false_value.variable === 'debtia.paymentLink' && ((this.lettervariables[element.id].false_value.amount_based_plan || this.lettervariables[element.id].false_value.period_based_plan) && !this.lettervariables[element.id].false_value.payment_date)) {
          this.turnSelectErrorOn(`#payment_date-${element.id}-false_value`)
          this.emptyMappableTrueFalseValue = true
        }
      })
    },
    assignClass(field) {
      let exists = false
      const entry = this.specialOptions.filter(e => e.name === field)
      if (entry.length > 0) {
        exists = true
      }
      return exists
    },
    noOfDaysChange(data, event) {
      this.lettervariables[event].functional_value = Number(data)
      this.$el.querySelector(`#noOfDays-${event}`).classList.remove('inputErrorClassField')
    },
    moduleChange(data, event) {
      this.lettervariables[event].functional_value = Number(data)
      const selector = document.getElementById(`prev-module-dropdown-${event}`)
      const ancestorWithClass = selector.closest('.vs__dropdown-toggle')
      ancestorWithClass.classList.remove('inputErrorClassField')
    },
    currencyStatementChange(data, event) {
      this.lettervariables[event].statement_id = String(data)
      const statementObject = this.statementsOptions.filter(e => e.value === String(data))
      this.lettervariables[event].statement_type = statementObject[0].type
      const selector = document.getElementById(`currency-statement-${event}`)
      const ancestorWithClass = selector.closest('.vs__dropdown-toggle')
      ancestorWithClass.classList.remove('inputErrorClassField')
    },
    currencyConversionChange(data, event) {
      this.lettervariables[event].currency_id = Number(data)
      const selector = document.getElementById(`convert-currency-${event}`)
      const ancestorWithClass = selector.closest('.vs__dropdown-toggle')
      ancestorWithClass.classList.remove('inputErrorClassField')
    },
    documentTypeChange(data, event) {
      this.lettervariables[event].base_types = data
      const selector = document.getElementById(`base-document-types-${event}`)
      const ancestorWithClass = selector.closest('.vs__dropdown-toggle')
      ancestorWithClass.classList.remove('inputErrorClassField')
    },
    fetchingDocumentChange(data, event) {
      this.lettervariables[event].document_order = data
      const selector = document.getElementById(`fetching-document-${event}`)
      const ancestorWithClass = selector.closest('.vs__dropdown-toggle')
      ancestorWithClass.classList.remove('inputErrorClassField')
    },
    getLetterTemplate() {
      const url = 'letters-api/list-all-letters?perPage=100000'
      const headers = {
        clientId: this.letter_client_id,
        secret: this.letter_secret,
      }
      axiosletter.get(url, {
        headers,
      }).then(response => {
        if (response.status === 200) {
          const records = response.data.data.data
          records.forEach(element => {
            const elementObj = { label: element.name, value: element.id }
            this.letterTemplateOptions.push(elementObj)
          })
        }
      })
    },
    changeTemplate() {
      this.busy = true
      this.templateVariables = []
      this.lettervariables = {}
      this.templateVariableOptions = []
      const url = `/letters-api/view-letter?templateID=${this.letterTemplate}`
      const headers = {
        clientId: this.letter_client_id,
        secret: this.letter_secret,
      }
      axiosletter.get(url, {
        headers,
      }).then(response => {
        if (response.status === 200) {
          setTimeout(() => {
            this.busy = false
            this.letterTemplateTitle = response.data.data.data.name
            const object = response.data.data.apiBody.customFields
            for (const [key] of Object.entries(object)) {
              const obj = {
                id: key,
                mappable: false,
              }
              this.templateVariables.push(obj)
              // console.log('templateVariables ', this.templateVariables)
            }
            this.attachVariables()
          }, 3000)
        }
      })
    },
    async attachVariables() {
      this.templateVariableOptions = [
        { label: 'clients.id', value: 'clients.id' },
        { label: 'clients.name', value: 'clients.name' },
        { label: 'clients.roadname', value: 'clients.roadname' },
        { label: 'clients.house_no', value: 'clients.house_no' },
        { label: 'clients.zipcode', value: 'clients.zipcode' },
        { label: 'clients.city', value: 'clients.city' },
        { label: 'clients.cvr', value: 'clients.cvr' },
        { label: 'clients.email', value: 'clients.email' },
        { label: 'debtors.name', value: 'debtors.name' },
        { label: 'debtors.phone', value: 'debtors.phone' },
        { label: 'debtors.email', value: 'debtors.email' },
        { label: 'debtors.contact_person', value: 'debtors.contact_person' },
        { label: 'debtor_addresses.road_name', value: 'debtor_addresses.road_name' },
        { label: 'debtor_addresses.house_no', value: 'debtor_addresses.house_no' },
        { label: 'debtor_addresses.zip_code', value: 'debtor_addresses.zip_code' },
        { label: 'debtor_addresses.city', value: 'debtor_addresses.city' },
        { label: 'debt_case_info.payment_amount', value: 'debt_case_info.payment_amount' },
        { label: 'debt_case_info.interest_rate_percentage', value: 'debt_case_info.interest_rate_percentage' },
        { label: 'debt_case_info.reminder_fee', value: 'debt_case_info.reminder_fee' },
        { label: 'debt_case_info.paid_amount', value: 'debt_case_info.paid_amount' },
        { label: 'debt_case_info.credit_note_amount', value: 'debt_case_info.credit_note_amount' },
        { label: 'debt_case_info.total_amount', value: 'debt_case_info.total_amount' },
        { label: 'debt_cases.id', value: 'debt_cases.id' },
        { label: 'debtor.co', value: 'debtor.co' },
        { label: 'debtor.addresses.place', value: 'debtor.addresses.place' },
        { label: 'debt_case_info.principal', value: 'debt_case_info.principal' },
        { label: 'debt_case_info.principal_rest', value: 'debt_case_info.principal_rest' },
        { label: 'debt_case_info.interest_rest', value: 'debt_case_info.interest_rest' },
        { label: 'debt_case_info.collection_fee_rest', value: 'debt_case_info.collection_fee_rest' },
        { label: 'debt_case_info.compensation_cost_rest', value: 'debt_case_info.compensation_cost_rest' },
        { label: 'debt_case_info.reminder_fee_rest', value: 'debt_case_info.reminder_fee_rest' },
        { label: 'debt_case_info.collection_cost_rest', value: 'debt_case_info.collection_cost_rest' },
        { label: 'debt_case_info.salary_rest', value: 'debt_case_info.salary_rest' },
        { label: 'debt_case_info.total_rest', value: 'debt_case_info.total_rest' },
        { label: 'Earliest Due Date', value: 'debt_case_info.due_date' },
        { label: 'Court Name', value: 'court.name' },
        { label: 'Court Road Name', value: 'court.road_name' },
        { label: 'Court House Number', value: 'court.house_number' },
        { label: 'Court Zipcode', value: 'court.zipcode' },
        { label: 'Court City', value: 'court.city' },
        { label: 'Court Phone', value: 'court.phone' },
        { label: 'Court Email', value: 'court.email' },
        { label: 'Court Bank Registration Number', value: 'court.regNo' },
        { label: 'Court Bank Account Number', value: 'court.accountNo' },
        { label: 'Court Short Name', value: 'court.shortName' },
        { label: 'Base Type', value: 'debtia.baseType' },
        { label: 'String X', value: 'string_x' },
        { label: 'Base Document Titles', value: 'debtia.baseDocumentTitles' },
        { label: 'Date of first interest entry', value: 'interest.first_entry' },
        { label: 'Date of last interest entry', value: 'interest.last_entry' },
        { label: 'VAT Exempted Client', value: 'debtia.vat_exempted_client' },
        { label: 'Case Presentation', value: 'debtia.case_presentation' },
        { label: 'Debtor CVR/CPR', value: 'debtia.debtor_cvr_cpr' },
        { label: 'Active installment plan creation date', value: 'active_installment_plan_creation_date' },
        { label: 'Next unpaid installment amount', value: 'next_unpaid_installment_amount' },
        { label: 'Next unpaid installment date', value: 'next_unpaid_installment_date' },
        { label: 'List of unpaid installments', value: 'list_of_unpaid_installments' },
        { label: 'DKK/EUR Converter', value: 'debtia.currencyConverter' },
        { label: 'dato felt', value: 'dato_felt' },
        { label: 'Auto FIK', value: 'auto_fik' },
        { label: 'Recepient Name', value: 'debtia.recepient_name' },
        { label: 'Recepient Contact Person', value: 'debtia.recepient_contact_person' },
        { label: 'Recepient Address Road Name', value: 'debtia.recepient_road_name' },
        { label: 'Recepient Address House Number', value: 'debtia.recepient_house_number' },
        { label: 'Recepient Address Zipcode', value: 'debtia.recepient_zipcode' },
        { label: 'Recepient Address City', value: 'debtia.recepient_city' },
        { label: 'Recepient Address Country', value: 'debtia.recepient_country' },
        { label: 'Recepient Address Place', value: 'debtia.recepient_place' },
        { label: 'Module Run Date', value: 'module_run_date' },
        { label: 'Interest Rate Percentage', value: 'interest_rate_percentage' },
        { label: 'Conditional Mappable', value: 'conditional_mappable' },
        { label: 'Letter Sent Date', value: 'letter_sent_date' },
        { label: 'Free Text', value: 'debtia.freeText' },
        { label: 'Payment Link', value: 'debtia.paymentLink' },
      ]

      await axios.get(`${constants.serverBaseUrl}/api/v2/debtiaapp/process/get-custom-variables`).then(response => {
        if (response.status) {
          const index = this.templateVariableOptions.length - this.specialOptions.length
          this.templateVariableOptions.splice(index, 0, ...response.data.data)
        }
      })

      await axios.get('/process/get-statement-vars').then(response => {
        if (response.status) {
          const index = this.templateVariableOptions.length - this.specialOptions.length
          this.templateVariableOptions.splice(index, 0, ...response.data.data)
        }
      })
    },
    submitSendLetterForm() {
      const emptyValues = this.templateVariables.filter(element => (
        !this.lettervariables[element.id]
        || (this.lettervariables[element.id] && this.lettervariables[element.id].functional_value === 0 && this.lettervariables[element.id].variable !== 'dato_felt')
        || (this.lettervariables[element.id].variable === 'debtia.currencyConverter' && (!this.lettervariables[element.id].currency_id || !this.lettervariables[element.id].statement_id))
        || (this.lettervariables[element.id].variable === 'interest_rate_percentage' && (this.lettervariables[element.id].base_types.length === 0 || !this.lettervariables[element.id].document_order))
        || (this.lettervariables[element.id].variable === 'letter_sent_date' && (this.lettervariables[element.id].letters.length === 0 || !this.lettervariables[element.id].order))
        || (this.lettervariables[element.id].variable === 'debtia.paymentLink' && (!this.lettervariables[element.id].debtor_email || !this.lettervariables[element.id].min_amount || !this.lettervariables[element.id].max_months || !this.lettervariables[element.id].interest_free_months || !this.lettervariables[element.id].payment_date.length === 0))
      ))
      const mappableValues = this.templateVariables.filter(element => element.mappable)
      if (mappableValues.length > 0) {
        this.checkMappableFields(mappableValues)
        this.mappableTrueFalse(mappableValues)
      }
      this.checkEmptyValues(emptyValues)
      if (this.emptyGeneralValues || this.emptyMappableValues || this.emptyMappableTrueFalseValue || this.minAmountError || this.maxMonthsError || this.interestFreeMonthsError) {
        this.errorMsg = true
      } else {
        const variable = this.receipientVars[this.receipient]
        const contactID = this.receipient === 'debtia.receipientsContact' ? this.contact : 0
        this.lettervariables.receipients = {
          key: variable,
          value: this.receipient,
          contact_id: contactID,
        }
        this.errorMsg = false
        this.spinnerOn = true
        const allDays = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']
        let enabledDays = {}

        const allSelected = this.selectedDays.length === allDays.length

        if (this.selectedDays.length === 0) {
          this.daysError = true
          this.spinnerOn = false
          return
        }

        if (allSelected) {
          enabledDays = { all: true }
        } else {
          enabledDays = {}
          allDays.forEach(day => {
            if (this.selectedDays.includes(day)) {
              enabledDays[day] = true
            }
          })
          enabledDays.all = false
        }

        const url = '/process/module/add'
        const processID = this.$route.params.id
        if (this.fileCategory.length > 0) {
          this.fileCategory.filter((e, i) => {
            if (e === 'baseDocuments') {
              this.baseDocumentAttachments = true
              this.fileCategory.splice(i, 1)
            }
            return true
          })
        }
        const dataObj = {
          process_id: Number(processID),
          module_id: 3,
          module_order: 1,
          letter_template_id: this.letterTemplate,
          custom_variables: this.lettervariables,
          letter_template_title: this.letterTemplateTitle,
          fileCategory: this.fileCategory,
          attach_base_documents: this.baseDocumentAttachments,
          skip_email: this.skipEmail,
          enabled_days: enabledDays,
        }
        if (this.conditionObject.moduleID > 0) {
          dataObj.depends_on = this.conditionObject.moduleID
          dataObj.condition = this.conditionObject.type
        }
        // console.log('dataObj is ', dataObj)
        axios.post(url, dataObj).then(response => {
          if (response.status === 200) {
            this.spinnerOn = false
            this.activeProcess = 0
            const returnObj = {
              parentID: this.conditionObject.parentID,
              depend: dataObj.depends_on,
            }
            returnObj.type = this.conditionObject.type ? this.conditionObject.type : 0
            this.$emit('closeSendLetterModal', returnObj)
          }
        })
      }
    },
    checkEmptyValues(values) {
      this.emptyGeneralValues = false
      values.forEach(element => {
        let selector = ''
        let classToPut = ''
        if ((this.lettervariables[element.id] && this.lettervariables[element.id].variable === 'debtia.paymentLink') && this.lettervariables[element.id].amount_based_plan && (!this.lettervariables[element.id].min_amount)) {
          const selector1 = `#min_amount-${element.id}`
          const elementHTML = this.$el.querySelector(selector1)
          const ancestorWithClass = elementHTML.closest('.form-control')
          ancestorWithClass.classList.add('inputErrorClassField')
          this.emptyGeneralValues = true
        }
        if ((this.lettervariables[element.id] && this.lettervariables[element.id].variable === 'debtia.paymentLink') && this.lettervariables[element.id].period_based_plan && (!this.lettervariables[element.id].max_months)) {
          const selector1 = `#max_months-${element.id}`
          const elementHTML = this.$el.querySelector(selector1)
          const ancestorWithClass = elementHTML.closest('.form-control')
          ancestorWithClass.classList.add('inputErrorClassField')
          this.emptyGeneralValues = true
        }
        if ((this.lettervariables[element.id] && this.lettervariables[element.id].variable === 'debtia.paymentLink') && (this.lettervariables[element.id].period_based_plan || this.lettervariables[element.id].amount_based_plan) && (!this.lettervariables[element.id].interest_free_months)) {
          const selector1 = `#interest_free_months-${element.id}`
          const elementHTML = this.$el.querySelector(selector1)
          const ancestorWithClass = elementHTML.closest('.form-control')
          ancestorWithClass.classList.add('inputErrorClassField')
          this.emptyGeneralValues = true
        }
        if ((this.lettervariables[element.id] && this.lettervariables[element.id].variable === 'debtia.paymentLink') && (this.lettervariables[element.id].period_based_plan || this.lettervariables[element.id].amount_based_plan) && (!this.lettervariables[element.id].payment_date)) {
          const selector1 = `#payment_date-${element.id}`
          this.turnSelectErrorOn(selector1)
          this.emptyGeneralValues = true
        }
        if (this.lettervariables[element.id] && this.lettervariables[element.id].variable === 'module_run_date' && this.lettervariables[element.id].functional_value === 0) {
          const selector1 = `#prev-module-dropdown-${element.id}`
          const elementHTML = this.$el.querySelector(selector1)
          const ancestorWithClass = elementHTML.closest('.vs__dropdown-toggle')
          ancestorWithClass.classList.add('inputErrorClassField')
          this.emptyGeneralValues = true
        } else if ((this.lettervariables[element.id] && this.lettervariables[element.id].variable === 'debtia.currencyConverter') && (!this.lettervariables[element.id].currency_id && !this.lettervariables[element.id].statement_id)) {
          const selector3 = `#currency-statement-${element.id}`
          const selector4 = `#convert-currency-${element.id}`

          const elementHTML3 = this.$el.querySelector(selector3)
          const ancestorWithClass3 = elementHTML3.closest('.vs__dropdown-toggle')
          ancestorWithClass3.classList.add('inputErrorClassField')

          const elementHTML4 = this.$el.querySelector(selector4)
          const ancestorWithClass4 = elementHTML4.closest('.vs__dropdown-toggle')
          ancestorWithClass4.classList.add('inputErrorClassField')

          this.emptyGeneralValues = true
        } else if ((this.lettervariables[element.id] && this.lettervariables[element.id].variable === 'debtia.currencyConverter') && (!this.lettervariables[element.id].currency_id && this.lettervariables[element.id].statement_id)) {
          const selector1 = `#convert-currency-${element.id}`
          const elementHTML = this.$el.querySelector(selector1)
          const ancestorWithClass = elementHTML.closest('.vs__dropdown-toggle')
          ancestorWithClass.classList.add('inputErrorClassField')

          this.emptyGeneralValues = true
        } else if ((this.lettervariables[element.id] && this.lettervariables[element.id].variable === 'debtia.currencyConverter') && (this.lettervariables[element.id].currency_id && !this.lettervariables[element.id].statement_id)) {
          const selector1 = `#currency-statement-${element.id}`
          const elementHTML = this.$el.querySelector(selector1)
          const ancestorWithClass = elementHTML.closest('.vs__dropdown-toggle')
          ancestorWithClass.classList.add('inputErrorClassField')
          this.emptyGeneralValues = true
        } else if ((this.lettervariables[element.id] && this.lettervariables[element.id].variable === 'interest_rate_percentage') && (this.lettervariables[element.id].base_types.length === 0 && !this.lettervariables[element.id].document_order)) {
          const selector3 = `#base-document-types-${element.id}`
          const selector4 = `#fetching-document-${element.id}`

          const elementHTML3 = this.$el.querySelector(selector3)
          const ancestorWithClass3 = elementHTML3.closest('.vs__dropdown-toggle')
          ancestorWithClass3.classList.add('inputErrorClassField')

          const elementHTML4 = this.$el.querySelector(selector4)
          const ancestorWithClass4 = elementHTML4.closest('.vs__dropdown-toggle')
          ancestorWithClass4.classList.add('inputErrorClassField')
          this.emptyGeneralValues = true
        } else if ((this.lettervariables[element.id] && this.lettervariables[element.id].variable === 'interest_rate_percentage') && (this.lettervariables[element.id].base_types.length === 0 && this.lettervariables[element.id].document_order)) {
          const selector1 = `#base-document-types-${element.id}`
          const elementHTML = this.$el.querySelector(selector1)
          const ancestorWithClass = elementHTML.closest('.vs__dropdown-toggle')
          ancestorWithClass.classList.add('inputErrorClassField')
          this.emptyGeneralValues = true
        } else if ((this.lettervariables[element.id] && this.lettervariables[element.id].variable === 'interest_rate_percentage') && (this.lettervariables[element.id].base_types.length > 0 && !this.lettervariables[element.id].document_order)) {
          const selector1 = `#fetching-document-${element.id}`
          const elementHTML = this.$el.querySelector(selector1)
          const ancestorWithClass = elementHTML.closest('.vs__dropdown-toggle')
          ancestorWithClass.classList.add('inputErrorClassField')
          this.emptyGeneralValues = true
        } else if ((this.lettervariables[element.id] && this.lettervariables[element.id].variable === 'letter_sent_date') && (this.lettervariables[element.id].letters.length === 0 && !this.lettervariables[element.id].order)) {
          const selector3 = `#select-letter-template-${element.id}`
          const selector4 = `#fetching-letters-${element.id}`

          const elementHTML3 = this.$el.querySelector(selector3)
          const ancestorWithClass3 = elementHTML3.closest('.vs__dropdown-toggle')
          ancestorWithClass3.classList.add('inputErrorClassField')

          const elementHTML4 = this.$el.querySelector(selector4)
          const ancestorWithClass4 = elementHTML4.closest('.vs__dropdown-toggle')
          ancestorWithClass4.classList.add('inputErrorClassField')
          this.emptyGeneralValues = true
        } else if ((this.lettervariables[element.id] && this.lettervariables[element.id].variable === 'letter_sent_date') && (this.lettervariables[element.id].letters.length === 0 && this.lettervariables[element.id].order)) {
          const selector1 = `#select-letter-template-${element.id}`
          const elementHTML = this.$el.querySelector(selector1)
          const ancestorWithClass = elementHTML.closest('.vs__dropdown-toggle')
          ancestorWithClass.classList.add('inputErrorClassField')
          this.emptyGeneralValues = true
        } else if ((this.lettervariables[element.id] && this.lettervariables[element.id].variable === 'letter_sent_date') && (this.lettervariables[element.id].letters.length > 0 && !this.lettervariables[element.id].order)) {
          const selector1 = `#fetching-letters-${element.id}`
          const elementHTML = this.$el.querySelector(selector1)
          const ancestorWithClass = elementHTML.closest('.vs__dropdown-toggle')
          ancestorWithClass.classList.add('inputErrorClassField')
          this.emptyGeneralValues = true
        } else if (this.lettervariables[element.id] && this.lettervariables[element.id].variable === 'debtia.paymentLink') {
          // bypass
        } else {
          selector = `.letter-template-${element.id}`
          classToPut = 'inputErrorClass'
          this.$el.querySelector(selector).classList.add(classToPut)
          this.emptyGeneralValues = true
        }
      })
    },
    checkMappableFields(values) {
      this.emptyMappableValues = false
      values.forEach(element => {
        const fields = this.$refs[`conditionalChild-${element.id}`][0].mappable_validation_fields[element.id]
        fields.forEach(field => {
          if ((field !== 'sub_statements' && field !== 'custom_variable_value*radio' && field !== 'datepicker' && (!this.lettervariables[element.id][field] || this.lettervariables[element.id][field].length === 0))
            || (field !== 'sub_statements' && field !== 'custom_variable_value*radio' && field === 'datepicker' && (!this.lettervariables[element.id].dacustom_variable_value || !this.$GetValidDate(this.lettervariables[element.id].dacustom_variable_value)))
            || (field !== 'sub_statements' && field !== 'custom_variable_value*radio' && typeof this.lettervariables[element.id][field] === 'string' && this.lettervariables[element.id][field].indexOf(':mm') !== -1)
            || (field !== 'sub_statements' && field === 'custom_variable_value*radio' && !this.lettervariables[element.id].custom_variable_value)
            || (field === 'sub_statements' && this.lettervariables[element.id].sub_statements.length === 0)
          ) {
            let searchedID = `${field}-${element.id}`
            if (field === 'datepicker') {
              searchedID = `custom_variable_value-${element.id}`
            }
            const elementHTML = document.getElementById(searchedID)
            // Add a class to the element
            if (elementHTML && !elementHTML.className.includes('vs__search')) {
              // debugger
              elementHTML.classList.add('inputErrorClassField')
            } else if (searchedID.includes('*radio')) {
              const radioelement = document.getElementById(`radioerror-${element.id}`)
              radioelement.style.display = 'block'
            } else {
              // debugger
              const ancestorWithClass = elementHTML.closest('.vs__dropdown-toggle')
              ancestorWithClass.classList.add('inputErrorClassField')
            }
            this.emptyMappableValues = true
          }
        })
      })
    },
    changeVariable(event, variable, index) {
      this.$el.querySelector(`.letter-template-${variable.id}`).classList.remove('inputErrorClass')
      if (this.templateVariables[index].mappable) {
        document.getElementById(`conditional-mappable-${variable.id}`).style.display = 'none'
        this.templateVariables[index].mappable = false
      }
      if (event === 'dato_felt') {
        document.getElementById(`div-wrapper-${variable.id}`).classList.add('div-wrapper')
        document.getElementById(`run-date-${variable.id}`).style.display = 'none'
        document.getElementById(`currency-conversion-${variable.id}`).style.display = 'none'
        document.getElementById(`date-${variable.id}`).style.display = 'block'
        document.getElementById(`interestrate-percentage-${variable.id}`).style.display = 'none'
        document.getElementById(`letter-sent-date-${variable.id}`).style.display = 'none'
        document.getElementById(`free-text-${variable.id}`).style.display = 'none'
        document.getElementById(`payment-link-${variable.id}`).style.display = 'none'
        this.lettervariables[variable.id] = {
          variable: event,
          functional_value: 0,
        }
      } else if (event === 'interest_rate_percentage') {
        document.getElementById(`div-wrapper-${variable.id}`).classList.add('div-wrapper')
        document.getElementById(`date-${variable.id}`).style.display = 'none'
        document.getElementById(`currency-conversion-${variable.id}`).style.display = 'none'
        document.getElementById(`run-date-${variable.id}`).style.display = 'none'
        document.getElementById(`interestrate-percentage-${variable.id}`).style.display = 'block'
        document.getElementById(`letter-sent-date-${variable.id}`).style.display = 'none'
        document.getElementById(`free-text-${variable.id}`).style.display = 'none'
        document.getElementById(`payment-link-${variable.id}`).style.display = 'none'
        this.lettervariables[variable.id] = {
          variable: event,
          functional_value: null,
          base_types: [],
          document_order: null,
        }
      } else if (event === 'debtia.currencyConverter') {
        if (this.prevModuleOptions.length === 0) {
          this.getPreviousModules()
        }
        document.getElementById(`div-wrapper-${variable.id}`).classList.add('div-wrapper')
        document.getElementById(`date-${variable.id}`).style.display = 'none'
        document.getElementById(`currency-conversion-${variable.id}`).style.display = 'block'
        document.getElementById(`run-date-${variable.id}`).style.display = 'none'
        document.getElementById(`interestrate-percentage-${variable.id}`).style.display = 'none'
        document.getElementById(`letter-sent-date-${variable.id}`).style.display = 'none'
        document.getElementById(`free-text-${variable.id}`).style.display = 'none'
        document.getElementById(`payment-link-${variable.id}`).style.display = 'none'
        this.lettervariables[variable.id] = {
          variable: event,
          functional_value: null,
          currency_id: null,
          statement_id: null,
          statement_type: null,
        }
      } else if (event === 'module_run_date') {
        if (this.prevModuleOptions.length === 0) {
          this.getPreviousModules()
        }
        document.getElementById(`div-wrapper-${variable.id}`).classList.add('div-wrapper')
        document.getElementById(`date-${variable.id}`).style.display = 'none'
        document.getElementById(`currency-conversion-${variable.id}`).style.display = 'none'
        document.getElementById(`run-date-${variable.id}`).style.display = 'block'
        document.getElementById(`interestrate-percentage-${variable.id}`).style.display = 'none'
        document.getElementById(`letter-sent-date-${variable.id}`).style.display = 'none'
        document.getElementById(`free-text-${variable.id}`).style.display = 'none'
        document.getElementById(`payment-link-${variable.id}`).style.display = 'none'
        this.lettervariables[variable.id] = {
          variable: event,
          functional_value: 0,
        }
      } else if (event === 'conditional_mappable') {
        this.lettervariables[variable.id] = { ...this.componentObject }
        document.getElementById(`div-wrapper-${variable.id}`).classList.add('div-wrapper')
        document.getElementById(`date-${variable.id}`).style.display = 'none'
        document.getElementById(`currency-conversion-${variable.id}`).style.display = 'none'
        document.getElementById(`run-date-${variable.id}`).style.display = 'none'
        document.getElementById(`interestrate-percentage-${variable.id}`).style.display = 'none'
        document.getElementById(`letter-sent-date-${variable.id}`).style.display = 'none'
        document.getElementById(`free-text-${variable.id}`).style.display = 'none'
        document.getElementById(`payment-link-${variable.id}`).style.display = 'none'
        this.templateVariables[index].mappable = true
        setTimeout(() => {
          document.getElementById(`conditional-mappable-${variable.id}`).style.display = 'block'
        }, 50)
        this.conditionalLetterVar = this.lettervariables[variable.id]
        setTimeout(() => {
          this.$refs[`conditionalChild-${variable.id}`][0].mappable_validation_fields[variable.id] = ['condition_id', 'condition_operator_id']
        }, 500)
      } else if (event === 'letter_sent_date' || event === 'debtia.case_presentation') {
        document.getElementById(`div-wrapper-${variable.id}`).classList.add('div-wrapper')
        document.getElementById(`date-${variable.id}`).style.display = 'none'
        document.getElementById(`currency-conversion-${variable.id}`).style.display = 'none'
        document.getElementById(`run-date-${variable.id}`).style.display = 'none'
        document.getElementById(`interestrate-percentage-${variable.id}`).style.display = 'none'
        document.getElementById(`letter-sent-date-${variable.id}`).style.display = 'block'
        document.getElementById(`letter-sent-date-order-${variable.id}`).style.display = event === 'letter_sent_date' ? 'block' : 'none'
        document.getElementById(`case-presentation-statements-${variable.id}`).style.display = event === 'debtia.case_presentation' ? 'block' : 'none'
        document.getElementById(`free-text-${variable.id}`).style.display = 'none'
        document.getElementById(`payment-link-${variable.id}`).style.display = 'none'
        this.lettervariables[variable.id] = {
          variable: event,
          functional_value: null,
          letters: [],
          order: null,
        }
      } else if (event === 'debtia.freeText') {
        document.getElementById(`div-wrapper-${variable.id}`).classList.add('div-wrapper')
        document.getElementById(`date-${variable.id}`).style.display = 'none'
        document.getElementById(`currency-conversion-${variable.id}`).style.display = 'none'
        document.getElementById(`run-date-${variable.id}`).style.display = 'none'
        document.getElementById(`interestrate-percentage-${variable.id}`).style.display = 'none'
        document.getElementById(`letter-sent-date-${variable.id}`).style.display = 'none'
        document.getElementById(`free-text-${variable.id}`).style.display = 'block'
        document.getElementById(`payment-link-${variable.id}`).style.display = 'none'
        this.lettervariables[variable.id] = {
          variable: event,
          functional_value: null,
          free_text_note: null,
        }
      } else if (event === 'debtia.paymentLink') {
        document.getElementById(`div-wrapper-${variable.id}`).classList.add('div-wrapper')
        document.getElementById(`date-${variable.id}`).style.display = 'none'
        document.getElementById(`currency-conversion-${variable.id}`).style.display = 'none'
        document.getElementById(`run-date-${variable.id}`).style.display = 'none'
        document.getElementById(`interestrate-percentage-${variable.id}`).style.display = 'none'
        document.getElementById(`letter-sent-date-${variable.id}`).style.display = 'none'
        document.getElementById(`free-text-${variable.id}`).style.display = 'none'
        document.getElementById(`payment-link-${variable.id}`).style.display = 'block'
        this.lettervariables[variable.id] = {
          variable: event,
          functional_value: null,
          module_type: 'letter',
          period_based_plan: this.periodBasePlan,
          amount_based_plan: this.amountBasePlan,
          max_months: this.maxMonth,
          min_amount: this.minAmount,
          interest_free_months: this.interestFreeMonths,
          payment_date: this.installmentStartDate,
          debtor_email: this.emailValue,
          debtor_phone: '',
          template_id: this.email_template_id,
          employee_name: JSON.parse(localStorage.getItem('userData')).data.name,
        }
      } else {
        const customVar = this.templateVariableOptions.filter(e => e.value === event && e.custom_variable === true)
        this.lettervariables[variable.id] = customVar.length > 0 ? {
          variable: event,
          functional_value: null,
          custom_variable: true,
        } : event
        document.getElementById(`div-wrapper-${variable.id}`).classList.remove('div-wrapper')
        document.getElementById(`date-${variable.id}`).style.display = 'none'
        document.getElementById(`currency-conversion-${variable.id}`).style.display = 'none'
        document.getElementById(`run-date-${variable.id}`).style.display = 'none'
        document.getElementById(`interestrate-percentage-${variable.id}`).style.display = 'none'
        document.getElementById(`letter-sent-date-${variable.id}`).style.display = 'none'
        document.getElementById(`payment-link-${variable.id}`).style.display = 'none'
      }
      const emptyValues = this.templateVariables.filter(element => !this.lettervariables[element.id])
      if (emptyValues.length === 0) {
        this.errorMsg = false
      }
    },
    async getFileCategories() {
      await axios.get('/settings/file-categories-dropdown').then(response => {
        if (response.status === 200) {
          this.fileCategories.push(...response.data.data)
        }
      }).catch(error => console.log(error))
    },
    async getPreviousModules() {
      const processID = this.$route.params.id
      await axios.get(`/process/get-previous-modules/${Number(processID)}`).then(response => {
        if (response.status === 200) {
          this.prevModuleOptions.push(...response.data.data)
        }
      }).catch(error => console.log(error))
    },
    async getConditions() {
      this.busy = true
      await axios.get('/process/get-conditions').then(response => {
        if (response.status === 200) {
          const conditionsData = response.data.data.variables.map(e => ({
            ...e, label: this.$t(e.label), value: e.value,
          }))
          this.conditions.push(...conditionsData)
          this.AirportsData.push(...response.data.data.airports)
          const conditionID = this.conditions.filter(e => e.label === 'Statements')
          this.statementConditionID = conditionID.length > 0 ? conditionID[0].value : 0
          const clientTypeID = this.conditions.filter(e => e.label === 'Check client type')
          this.clientTypeConditionID = clientTypeID.length > 0 ? clientTypeID[0].value : 0
          const interestTypeID = this.conditions.filter(e => e.label === 'Is Interest Type Custom?')
          this.interestTypeConditionID = interestTypeID.length > 0 ? interestTypeID[0].value : 0
          const clientCollectionTypeID = this.conditions.filter(e => e.label === 'Is client Collection Type?')
          this.clientCollectionTypeID = clientCollectionTypeID.length > 0 ? clientCollectionTypeID[0].value : 0
          this.busy = false
        }
      }).catch(error => console.log(error))
    },
    sentLetterChange(data, event) {
      const filteredData = this.letterTemplateOptions.filter(item => data.includes(item.value)).map(item => ({ id: item.value, title: item.label }))
      this.lettervariables[event].letters = filteredData
      const selector = document.getElementById(`select-letter-template-${event}`)
      const ancestorWithClass = selector.closest('.vs__dropdown-toggle')
      ancestorWithClass.classList.remove('inputErrorClassField')
    },
    fetchingLetterChange(data, event) {
      this.lettervariables[event].order = data
      const selector = document.getElementById(`fetching-letters-${event}`)
      const ancestorWithClass = selector.closest('.vs__dropdown-toggle')
      ancestorWithClass.classList.remove('inputErrorClassField')
    },
    async getStatements() {
      this.busy = true
      await axios.get('/settings/get-statement-settings').then(response => {
        if (response.status === 200) {
          this.statements = response.data.data.statements.filter(e => e.status === 1 && e.key !== '0000' && e.key !== '9999' && e.key !== '99999').map(e => ({
            label: this.$t(e.da_name), value: e.id,
          }))
          this.busy = false
        }
      }).catch(error => console.log(error))
    },
    removeErrorBorder(id, select) {
      if (select) {
        const dropdown = document.getElementById(`${id}`)
        const selector = dropdown.querySelector('.vs__dropdown-toggle')
        selector.classList.remove('inputErrorClassField')
      } else {
        const selector = document.getElementById(id)
        selector.classList.remove('inputErrorClassField')
      }
    },
    collectionStatement(data, event) {
      this.lettervariables[event].functional_value = data
    },
    assignFreeTextNote(data, event) {
      this.lettervariables[event].free_text_note = data
    },
    /**
     * Updates the installment plan fields based on the input data
     * @param {array|string|boolean|number} data - the input data
     * @param {number} id - the id of the debtor
     * @param {string} key - the key of the field to update
     * @description
     * This function is used to update the installment plan fields based on the input data.
     * It removes the inputErrorClassField class from the parent element of the input field,
     * and it also updates the emailvariables object with the new data.
     * If the key is 'debtor_email', it also updates the class of the letter template element
     * to show or hide the inputErrorClass class.
     * Finally, it updates the display style of the min_amount, max_months and interest_free_months
     * elements based on the values of the amount_based_plan and period_based_plan fields.
     */
    updateInstallmentPlanFields(data, id, key) {
      // This condition is used to check if the user has inputted a value in the min_amount field
      // that is less than 100. If the condition is true, we show an error message and prevent the
      // user from saving the page.
      if (key === 'min_amount') {
        if (parseInt(data, 10) < 100) {
          this.minAmountError = true
        } else {
          this.minAmountError = false
        }
      }
      // This condition is used to check if the user has inputted a value in the max_months field
      // that is less than 1. If the condition is true, we show an error message and prevent the
      // user from saving the page.
      if (key === 'max_months') {
        if (parseInt(data, 10) < 1) {
          this.maxMonthsError = true
        } else {
          this.maxMonthsError = false
        }
      }
      // This condition is used to check if the user has inputted a value in the interest_free_months field
      // that is less than 1 or greater than 3. If the condition is true, we show an error message and
      // prevent the user from saving the page.
      if (key === 'interest_free_months') {
        if (parseInt(data, 10) < 0) {
          this.interestFreeMonthsError = true
        } else {
          this.interestFreeMonthsError = false
        }
      }

      this.lettervariables[id][key] = data

      if (key === 'amount_based_plan') {
        const minAmountElement = document.getElementById(`col-min_amount-${id}`)
        minAmountElement.style.display = this.lettervariables[id][key] ? 'block' : 'none'
      }

      if (key === 'period_based_plan') {
        const maxMonthsElement = document.getElementById(`col-max_months-${id}`)
        maxMonthsElement.style.display = this.lettervariables[id][key] ? 'block' : 'none'
      }

      if (key === 'amount_based_plan' || key === 'period_based_plan') {
        const interestFreeMonthsElement = document.getElementById(`col-interest_free_months-${id}`)
        interestFreeMonthsElement.style.display = (this.lettervariables[id].amount_based_plan || this.lettervariables[id].period_based_plan) ? 'block' : 'none'
        const paymentDateElement = document.getElementById(`col-payment_date-${id}`)
        paymentDateElement.style.display = (this.lettervariables[id].amount_based_plan || this.lettervariables[id].period_based_plan) ? 'block' : 'none'
      }
    },
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  .emailSubmitBtn {
    width: 100%;
  }

  .inputErrorClass .vs__dropdown-toggle{
    border-color: red !important;
  }

  .inputErrorClassField{
    border-color: red !important;
  }

  #fieldserror {
    color: red;
  }

  .showdates {
    display: none;
    margin-top: 10px;
  }

  .autofik {
    margin-left: -10px;
    width: 106%;
    border-radius: 4px;
    padding: 10px;
    color: white;
    background-color: #5fb3ac !important;
    box-shadow: 1px 1px 2px #d3e8e6, 0 0 15px #d3e8e6, 0 0 2px #d3e8e6;
  }

  div.div-wrapper {
    border: 1px solid #d8d6de;
    border-radius: 5px;
    padding: 10px 10px 0px 10px;
  }
.optionsClass {
  margin-bottom: 10px;
}

.amount-period-base-divs {
  padding: 15px 0px 5px 0px;
  border: 1px solid #d8d6dd;
  margin: 0px 15px 15px 15px;
  border-radius: 10px;
}
</style>
